import {
  PROFESSIONAL_CERTIFICATE as SEARCH_PRODUCT_CERTIFICATE,
  COURSE as SEARCH_PRODUCT_COURSE,
  DEGREE as SEARCH_PRODUCT_DEGREE,
  MASTERTRACK as SEARCH_PRODUCT_MASTERTRACK,
  GUIDED_PROJECT as SEARCH_PRODUCT_PROJECT,
  SPECIALIZATION as SEARCH_PRODUCT_SPECIALIZATION,
  RHYME_PROJECT as SEARCH_RHYME_PROJECT,
  SPECIALIZATION_ENTITY_TYPE,
} from 'bundles/search-common/constants/entityTypes';
import { savedProductTypes } from 'bundles/unified-description-page-common/constants';

const savingSupportedProducts = {
  SPECIALIZATION: 's12n',
  CERTIFICATE: 'professional_certificate',
  DEGREE: 'degree',
  MASTERTRACK: 'mastertrack',
  GUIDED_PROJECT: 'project',
  COURSE: 'course',
  SEARCH_CARD: 'search_card',
} as const;

const SEARCH_PAGE_PRODUCT_PROJECT = 'GUIDED PROJECT';
const SAVED_TAB_MASTERTRACK = 'MASTERTRACK® CERTIFICATE';

// using case to allow for simple addition of text/sources/types
export const getSavingProductType = (productType: string | undefined): string => {
  switch (productType) {
    case savingSupportedProducts.COURSE:
    case SEARCH_PRODUCT_COURSE:
      return savedProductTypes.COURSE;
    case SPECIALIZATION_ENTITY_TYPE:
    case savingSupportedProducts.SPECIALIZATION:
    case SEARCH_PRODUCT_SPECIALIZATION:
      return savedProductTypes.SPECIALIZATION;
    case savingSupportedProducts.GUIDED_PROJECT:
    case SEARCH_PRODUCT_PROJECT:
    case SEARCH_RHYME_PROJECT:
    case SEARCH_PAGE_PRODUCT_PROJECT:
      return savedProductTypes.GUIDED_PROJECT;
    case savingSupportedProducts.CERTIFICATE:
    case SEARCH_PRODUCT_CERTIFICATE:
      return savedProductTypes.PROFESSIONAL_CERTIFICATE;
    case savingSupportedProducts.MASTERTRACK:
    case SEARCH_PRODUCT_MASTERTRACK:
    case SAVED_TAB_MASTERTRACK:
      return savedProductTypes.MASTERTRACK;
    case savingSupportedProducts.DEGREE:
    case SEARCH_PRODUCT_DEGREE:
      return savedProductTypes.DEGREE;
    default:
      return savedProductTypes.INVALID;
  }
};
